import { z } from "zod";
export const DTOScimMeta = z.object({
    resourceType: z.string().optional(),
    created: z.string().datetime().optional(),
    lastModified: z.string().datetime().optional(),
    location: z.string().url().optional(),
    version: z.string().optional(),
});
